"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToggle = void 0;
const react_1 = require("react");
const useToggle = (initialIsOpen = false) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(initialIsOpen);
    const open = (0, react_1.useCallback)(() => setIsOpen(true), []);
    const close = (0, react_1.useCallback)(() => setIsOpen(false), []);
    const toggle = (0, react_1.useCallback)(() => setIsOpen(() => !isOpen), [isOpen]);
    return {
        close,
        isOpen,
        open,
        toggle,
    };
};
exports.useToggle = useToggle;
//# sourceMappingURL=index.js.map